<template>
  <div>
    <b-button 
      :disabled="isRunningJob" 
      variant="success" 
      class="modern-btn"
      @click="showModal"
    >
      <i v-if="!isRunningJob" class="fa fa-file-powerpoint-o mr-2"></i>
      <b-spinner v-if="isRunningJob" small class="mr-2"></b-spinner>
      <span v-if="isRunningJob">Generando PowerPoint...</span>
      <span v-else>Generar PowerPoint</span>
    </b-button>

    <b-modal v-model="showDateRangeModal" title="Selecciona un Rango de Tiempo" @ok="runPptExportable">
      <b-form-group label="Ordernar por:">
        <b-form-select v-model="selectedOrder" :options="sortOrderOptions"></b-form-select>
      </b-form-group>
      <b-form-group label="Desde:" label-for="input-date-from">
        <b-form-datepicker
          id="input-date-from"
          v-model="dateRange.start"
          :max="dateRange.end"
          start-weekday="1"
          :required="true"
        />
      </b-form-group>
      <b-form-group label="Hasta:" label-for="input-date-to">
        <b-form-datepicker
          id="input-date-to"
          v-model="dateRange.end"
          start-weekday="1"
          :min="dateRange.start"
          :required="true"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
  import BaseDateRange from '../../../../app/shared/components/BaseDateRange'
  import {trade} from '../../../../services/api/ExpertoRetail'
  import {ref, onUnmounted, computed} from '@vue/composition-api'
  import moment from 'moment'

  export default {
    name: "ExportablePpt",
    components: { BaseDateRange },
    setup (props, context) {
      let pollInterval = null
      const isRunningJob = ref(false)
      const showDateRangeModal = ref(false)
      // Define the date range to last 45 days
      const selectedOrder = ref('created_at_descending') // Default value
      const sortOrderOptions = [
        { value: 'created_at_descending', text: 'Fecha descendiente' },
        { value: 'created_at_ascending', text: 'Fecha ascendente' },
        { value: 'retail', text: 'Retail' },
        { value: 'store', text: 'Tienda' }
      ]

      const dateRange = ref({
        start: moment().subtract(45, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      })

      const newsFeedMetrics = ref([])

      const updateDateFrom = (event) => {
        dateRange.value.start = event
      }

      const updateDateTo = (event) => {
        dateRange.value.end = event
      }

      const makeToast = (body, title, variant = 'danger') => {
        context.root.$bvToast.toast(body, {
          title: title,
          autoHideDelay: 5000,
          appendToast: false,
          solid: true,
          variant: variant
        })
      }

      const downloadFile = async (url) => {
        try {
          await trade.downloadPowerPoint()
        } catch (e) {
          makeToast('Ha ocurrido un error generando datos', 'Error')
        }
      }

      const showModal = () => {
        showDateRangeModal.value = true
      }

      const runPptExportable = async () => {
        try {
          isRunningJob.value = true
          showDateRangeModal.value = false
          const job = await trade.runPptExportable(dateRange.value.start, dateRange.value.end, selectedOrder.value)
          pollJobStatus(job.job_id)
        } catch (e) {
          isRunningJob.value = false
          makeToast('Ha ocurrido un error generando datos', 'Error')
          throw e
        }
      }

      const pollJobStatus = (JobId) => {
        try {
          const timeout = Date.now() + 600000
          pollInterval = setInterval(async () => {
            if (timeout < Date.now()) {
              clearPollInterval()
              makeToast('Se ha superado el tiempo de espera', 'Error')
              return
            }
            const response = await trade.pollPptExportableJob(JobId)
            if (response.status === 'DONE') {
              clearPollInterval()
              trade.downloadPowerPoint(response.presigned_url)
            } else if ((response.status === 'ERROR')) {
              clearPollInterval()
              makeToast('Ha ocurrido un error generando datos', 'Error')
            }
          }, 5000)
        } catch (e) {
          makeToast('Ha ocurrido un error generando datos', 'Error')
        }
      }

      const clearPollInterval = () => {
        isRunningJob.value = false
        clearInterval(pollInterval)
        pollInterval = null
      }

      // Ensure that the interval is cleared when the component is destroyed.
      onUnmounted(clearPollInterval)

      return {
        isRunningJob,
        runPptExportable,
        showDateRangeModal,
        dateRange,
        showModal,
        updateDateFrom,
        updateDateTo,
        selectedOrder,
        sortOrderOptions
      }
    }
  }
</script>
<style scoped>
.modern-btn {
  padding: 0.5rem 1rem;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 0.9rem;
}

.modern-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.modern-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/expertoRetail/views/trade/components/ExportablePpt.vue